module.exports = __webpack_public_path__ + "img/ic_stoprent.626f8917.svg";